'use strict';
import angular from 'angular';

export default class ApplicationController {
  /*@ngInject*/
  constructor($http, $scope, Auth) {
    var vm = this;
    vm.loading = true

    fetchApplications()

    function fetchApplications() {
      Auth.getCurrentUser().then(function(user) {
        vm.isAdmin = Auth.isAdminSync()
        vm.user = user
        if (Auth.isAdminSync()) {
          $http.get('/api/applications').then(response => {
            vm.data = response.data
            vm.loading = false
          })
        } else {
          $http.get('/api/users/my/applications').then(response => {
            vm.data = response.data.Applications
            vm.user = response.data
            vm.loading = false
          })
        }
      })
    }

    vm.deletePopup = function(app) {
      vm.appToDelete = app;
      $('#deleteApp').modal('show');
    }


    vm.delete = function(app) {
      $http.delete('/api/applications/' + vm.appToDelete._id).then(function(res) {
        vm.data.splice(vm.data.indexOf(vm.appToDelete), 1);
        vm.appToDelete = undefined;
        $('#deleteApp').modal('hide');
      }, function(error) {
        if (error.status == "404") {
          $state.go('application_main');
        }
        console.log(error);
      });
    }

    vm.download = function(appId, event) {
      $http.get('/api/applications/download/' + appId).then(function(res) {
        window.open(res.data.url);
      });
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/application/applications/applications.controller.js